import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { FileUpload } from 'components/FileUpload';
import {
  FILE,
  FILE_FETCHED,
  FILE_FORMAT_ERROR,
  getDescriptions,
  MAX_SIZE_ERROR,
  ModalStatusType,
  NO_FILE,
  REPLACING_FILE,
} from 'components/FileUpload/paramsByState';
import {
  getDiscontinuedReferencesFileInformation,
  getDiscontinuedReferencesFileInformationForRequest,
  getDiscontinuedReferencesFileModalStatus,
  getDiscontinuedReferencesFileUploadStatus,
  setDiscontinuedReferencesFileInformationForRequest,
  setDiscontinuedReferencesFileModalStatus,
  uploadFileDiscontinuedReferencesRequestSaga,
} from 'domains/discontinuedReferences/DiscontinuedReferences.store';

const DiscontinuedReferencesFileUpload = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const fileInfoFetched = useSelector(getDiscontinuedReferencesFileInformation);
  const fileInfoRequest = useSelector(getDiscontinuedReferencesFileInformationForRequest);
  const fileUploadStatus = useSelector(getDiscontinuedReferencesFileUploadStatus);

  const modalStatus = useSelector(getDiscontinuedReferencesFileModalStatus);

  const setModalStatus = (status: ModalStatusType) => {
    dispatch(setDiscontinuedReferencesFileModalStatus(status));
  };

  const validateFile = (file: File) => {
    if (!file.name.endsWith('.csv')) {
      setModalStatus(FILE_FORMAT_ERROR);
      return false;
    } else if (file.size > 2000 * 1024) {
      setModalStatus(MAX_SIZE_ERROR);
      return false;
    } else {
      setModalStatus(FILE);
      return true;
    }
  };

  const uploadFile = (fileName: string, _fileSize: number, fileBase64: string) => {
    dispatch(
      uploadFileDiscontinuedReferencesRequestSaga({
        fileName,
        fileBase64,
      }),
    );
    dispatch(setDiscontinuedReferencesFileInformationForRequest({ fileName }));
  };

  const handleNoFile = () => {
    setModalStatus(NO_FILE);
  };

  return (
    <FileUpload
      template={{
        link: '/fileTemplates/discontinued_renault_references_template.csv',
        fileName: 'Discontinued Renault references.csv',
      }}
      handleFileBase64={uploadFile}
      validateFile={validateFile}
      handleNoFile={handleNoFile}
      status={modalStatus}
      descriptions={getDescriptions(t, modalStatus, { size: 2, unit: 'MB' })}
      currentFile={
        modalStatus === FILE
          ? {
              fileType: 'CSV',
              fileName: fileUploadStatus === FILE_FETCHED ? fileInfoFetched.fileName : fileInfoRequest.fileName,
              fileBase64: '',
            }
          : undefined
      }
      isProcessing={fileUploadStatus === REPLACING_FILE}
    />
  );
};

export default DiscontinuedReferencesFileUpload;
